var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 33.6666C7.79516 33.6666 0.333496 26.2049 0.333496 16.9999C0.333496 7.79492 7.79516 0.333252 17.0002 0.333252C26.2052 0.333252 33.6668 7.79492 33.6668 16.9999C33.6668 26.2049 26.2052 33.6666 17.0002 33.6666ZM17.0002 30.3333C20.5364 30.3333 23.9278 28.9285 26.4283 26.428C28.9287 23.9275 30.3335 20.5361 30.3335 16.9999C30.3335 13.4637 28.9287 10.0723 26.4283 7.57183C23.9278 5.07134 20.5364 3.66659 17.0002 3.66659C13.4639 3.66659 10.0726 5.07134 7.57207 7.57183C5.07159 10.0723 3.66683 13.4637 3.66683 16.9999C3.66683 20.5361 5.07159 23.9275 7.57207 26.428C10.0726 28.9285 13.4639 30.3333 17.0002 30.3333ZM17.0002 14.6433L21.7135 9.92825L24.0718 12.2866L19.3568 16.9999L24.0718 21.7133L21.7135 24.0716L17.0002 19.3566L12.2868 24.0716L9.9285 21.7133L14.6435 16.9999L9.9285 12.2866L12.2868 9.92825L17.0002 14.6433Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesCircleGreen);
export default __webpack_public_path__ + "static/media/times-circle-green.ac0de39b98e20ff8b56cd39f722263e8.svg";
export { ForwardRef as ReactComponent };